/**
 * Labstep
 *
 * @module components/FilterPost/Active/Label
 * @desc Filter Post Active Label
 */

import { FilterDeletedActivePost } from 'labstep-web/components/Filter/Deleted/Active/Post';
import { FilterMetadataActivePost } from 'labstep-web/components/Filter/Metadata/Active/Post';
import FilterTagActivePost from 'labstep-web/components/Filter/Tag/Active/Post';
import { FilterUserActivePost } from 'labstep-web/components/Filter/User/Active/Post';
import { FilterPostNewIndexBooleanActivePost } from 'labstep-web/components/FilterPost/NewIndex/Boolean/Active/Post';
import { FilterPostNewIndexDateActivePost } from 'labstep-web/components/FilterPost/NewIndex/Date/Active/Post';
import { FilterPostNewIndexDeletedActivePost } from 'labstep-web/components/FilterPost/NewIndex/Deleted/Active/Post';
import { FilterPostNewIndexDeviceActivePost } from 'labstep-web/components/FilterPost/NewIndex/Device/Active/Post';
import { FilterPostNewIndexEntityActivePost } from 'labstep-web/components/FilterPost/NewIndex/Entity/Active/Post';
import { FilterPostNewIndexEntityStateActivePost } from 'labstep-web/components/FilterPost/NewIndex/EntityState/Active/Post';
import { FilterPostNewIndexMetadataActivePost } from 'labstep-web/components/FilterPost/NewIndex/Metadata/Active/Post';
import { FilterPostNewIndexMetadataExperimentWorkflowActivePost } from 'labstep-web/components/FilterPost/NewIndex/MetadataExperimentWorkflow/Active/Post';
import { FilterPostNewIndexNumericActivePost } from 'labstep-web/components/FilterPost/NewIndex/Numeric/Active/Post';
import { FilterPostNewIndexOptionsActivePost } from 'labstep-web/components/FilterPost/NewIndex/Options/Active/Post';
import { FilterPostNewIndexProtocolActivePost } from 'labstep-web/components/FilterPost/NewIndex/Protocol/Active/Post';
import { FilterPostNewIndexResourceActivePost } from 'labstep-web/components/FilterPost/NewIndex/Resource/Active/Post';
import { FilterPostNewIndexResourceItemActivePost } from 'labstep-web/components/FilterPost/NewIndex/ResourceItem/Active/Post';
import { FilterPostNewIndexResourceLocationActivePost } from 'labstep-web/components/FilterPost/NewIndex/ResourceLocation/Active/Post';
import { FilterPostNewIndexStatusTypeActivePost } from 'labstep-web/components/FilterPost/NewIndex/StatusType/Active/Post';
import { FilterPostNewIndexTextActivePost } from 'labstep-web/components/FilterPost/NewIndex/Text/Active/Post';
import { FilterPostNewIndexUserActivePost } from 'labstep-web/components/FilterPost/NewIndex/User/Active/Post';
import { FilterPostReportDateActivePost } from 'labstep-web/components/FilterPost/Report/Date/Active/Post';
import { FilterPostReportEntityActivePost } from 'labstep-web/components/FilterPost/Report/Entity/Active/Post';
import { FilterPostReportMetadataActivePost } from 'labstep-web/components/FilterPost/Report/Metadata/Active/Post';
import { FilterPostReportMetadataHasValueActivePost } from 'labstep-web/components/FilterPost/Report/MetadataHasValue/Active/Post';
import { FilterPostReportNumericActivePost } from 'labstep-web/components/FilterPost/Report/Numeric/Active/Post';
import { FilterPostReportResourceLocationActivePost } from 'labstep-web/components/FilterPost/Report/ResourceLocation/Active/Post';
import { FilterPostReportTextActivePost } from 'labstep-web/components/FilterPost/Report/Text/Active/Post';
import { MoleculeFilterActivePost } from 'labstep-web/components/Molecule/Filter/Active/Post';
import { ResourceLocationFilterActivePost as FilterResourceLocationActivePost } from 'labstep-web/components/ResourceLocation/Filter/Active/Post';
import type React from 'react';
import type { FilterPostActiveLabelProps } from './types';

export const FilterPostActiveLabel: React.FC<
  FilterPostActiveLabelProps
> = (props): React.ReactElement | null => {
  if (props.entityView && props.entityView.context === 'reporting') {
    return (
      <>
        <FilterPostReportEntityActivePost {...props} />
        <FilterPostReportTextActivePost {...props} />
        <FilterPostReportDateActivePost {...props} />
        <FilterPostReportMetadataActivePost {...props} />
        <FilterPostReportNumericActivePost {...props} />
        <FilterPostReportResourceLocationActivePost {...props} />
        <FilterPostReportMetadataHasValueActivePost {...props} />
      </>
    );
  }
  if (props.entityView && props.entityView.context !== 'reporting') {
    return (
      <>
        <FilterPostNewIndexBooleanActivePost {...props} />
        <FilterPostNewIndexOptionsActivePost {...props} />
        <FilterPostNewIndexDateActivePost {...props} />
        <FilterPostNewIndexTextActivePost {...props} />
        <FilterPostNewIndexNumericActivePost {...props} />
        <FilterPostNewIndexMetadataActivePost {...props} />
        <FilterPostNewIndexMetadataExperimentWorkflowActivePost
          {...props}
        />
        <FilterPostNewIndexResourceLocationActivePost {...props} />
        <FilterPostNewIndexEntityStateActivePost {...props} />
        <FilterPostNewIndexStatusTypeActivePost {...props} />
        <FilterPostNewIndexDeletedActivePost {...props} />
        <FilterPostNewIndexUserActivePost {...props} />
        <FilterPostNewIndexDeviceActivePost {...props} />
        <FilterPostNewIndexProtocolActivePost {...props} />
        <FilterPostNewIndexResourceActivePost {...props} />
        <FilterPostNewIndexResourceItemActivePost {...props} />
        <FilterPostNewIndexEntityActivePost {...props} />
        <MoleculeFilterActivePost {...props} />
        <FilterTagActivePost {...props} />
      </>
    );
  }

  return (
    <>
      <FilterPostNewIndexBooleanActivePost {...props} />
      <FilterPostNewIndexOptionsActivePost {...props} />
      <FilterPostNewIndexDateActivePost {...props} />
      <FilterPostNewIndexTextActivePost {...props} />
      <FilterPostNewIndexNumericActivePost {...props} />
      <FilterResourceLocationActivePost {...props} />
      <FilterUserActivePost {...props} />
      <FilterMetadataActivePost {...props} />
      <FilterDeletedActivePost {...props} />
      <MoleculeFilterActivePost {...props} />
      <FilterTagActivePost {...props} />
    </>
  );
};
